







import {
  Vue,
  Component,
  Watch,
  Prop
} from "@/shared/vuepack";
import _ from "lodash";
import { FetchState } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";


@Component
export default class Logo extends Vue {
  userStore = useUserStore();
  portalCustomizationStore = usePortalCustomizationStore();

  @Prop()
  width: number;

  @Prop()
  blueLogo: boolean;

  @Prop()
  employerLogo: boolean;

  @Prop()
  partnerIdOverride: number;

  @Watch("$route.query.partner")
  getCustomizationsForPartnerChange () {
    const partnerId = _.toSafeInteger((this.$route.query.partner || this.portalCustomizationStore.partnerId));
    const assetRequest = { employerId: 0, partnerId };

    if (this.partnerIdOverride) {
      this.portalCustomizationStore.getUserLogo(this.partnerIdOverride);
      this.portalCustomizationStore.getCustomDebitCardImage(this.partnerIdOverride);
    }

    if (this.employerLogo && this.userStore.accountHolderEmployerId) {
      assetRequest.employerId = this.userStore.accountHolderEmployerId;
      this.portalCustomizationStore.getUserEmployerLogo(assetRequest);
    }

    if (assetRequest.partnerId || !this.employerLogo) {
      this.portalCustomizationStore.getUserLogo(assetRequest.partnerId);
      this.portalCustomizationStore.getCustomDebitCardImage(partnerId);
    }
  }

  @Watch("userStore.accountHolderEmployerId")
  getCustomizationsForEmployerChange () {
    const partnerId = _.toSafeInteger((this.$route.query.partner || this.portalCustomizationStore.partnerId));
    const assetRequest = { employerId: 0, partnerId };

    if (this.employerLogo && this.userStore.accountHolderEmployerId) {
      assetRequest.employerId = this.userStore.accountHolderEmployerId;
      this.portalCustomizationStore.getUserEmployerLogo(assetRequest);
    }
    if (assetRequest.partnerId && !this.employerLogo) {
      this.portalCustomizationStore.getUserLogo(assetRequest.partnerId);
      this.portalCustomizationStore.getCustomDebitCardImage(partnerId);
    }
  }

  get isLogoLoaded () {
    return (this.portalCustomizationStore.isLoaded && !this.employerLogo) ||
        (this.employerLogo && this.portalCustomizationStore.isEmployerLogoLoaded &&
            this.portalCustomizationStore.employerLogoSrc);
  }

  get imgSrc () {
    if (!this.portalCustomizationStore.isPartnerCustomLogo && !this.employerLogo) {
      if (this.blueLogo) {
        return require("../../assets/bend_logo_navy_blue.svg");
      }
      return require("../../assets/logo.svg");
    }
    if (this.employerLogo) {
      return this.portalCustomizationStore.employerLogoSrc;
    } else {
      return this.portalCustomizationStore.partnerLogoSrc;
    }
  }

  mounted () {
    if (((this.portalCustomizationStore.partnerId || this.$route.query.partner)
            || !!this.userStore.accountHolderEmployerId) &&
        (!this.portalCustomizationStore.partnerLogoSrc || !this.portalCustomizationStore.employerLogoSrc)) {

      const assetRequest = {
        employerId: 0,
        partnerId: this.$route.query.partner || this.portalCustomizationStore.partnerId
      };

      if (this.employerLogo && this.userStore.accountHolderEmployerId) {
        assetRequest.employerId = this.userStore.accountHolderEmployerId;
        this.portalCustomizationStore.getUserEmployerLogo(assetRequest as any);
      }

      if (assetRequest.partnerId && !this.employerLogo) {
        this.portalCustomizationStore.getUserLogo(assetRequest.partnerId);
        this.portalCustomizationStore.getCustomDebitCardImage((this.$route.query.partner
            || this.portalCustomizationStore.partnerId) as number);
      }
    } else {
      if (!this.$route.query.partner && !this.portalCustomizationStore.isPartnerCustomizationEnabled) {
        this.portalCustomizationStore.setLogoFetchState(FetchState.Loaded);
      }
    }
  }
}
